<template>
  <div class="container">
        <div ref="content">
            <div class="text-center">
                <h2>Informe:  {{nombreinforme}}</h2>
                <p v-html="fecha"></p>
            </div>
            <div>
                <p v-html="descripcionactividad" class="d-inline-flex py-5 px-5 bd-highlight"></p>
            </div> 
            <div class="text-center">
                <h4>Galería de Imágenes</h4>
            </div>  
                <div v-if="imagendesc !=false" >
                    <div class="container">
                            <div class="row">
                                <b-card-group deck v-for="(img,index) in imagenes" :key="index" class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                                    <b-card title="" :img-src="img" img-alt="imagen" img-center img-height="60%" img-widt="10%">
                                        <b-card-text>
                                        </b-card-text>
                                    </b-card>
                                </b-card-group>
                            </div>
                    </div>
                </div>
                <div class="text-center">
                    <button @click.prevent="imprimirInforme">Imprimir</button>
                    <button @click.prevent="imprimirPDF">PDF</button>
                    <button @click.prevent="exportPdf(imagenes)">PDF</button>
                </div>  
                
                
        </div> 
  </div>
</template>

<script>
import { storage }  from '../main'; 
const refe = storage.ref();
import   jsPDF   from 'jspdf'


export default {
    name:'VerInforme',
    data(){
        return{
            imagenes:[],
            imagendesc:false,
            id:'',
            fecha:'',
            nombreproyecto:'',
            nombreinforme:'', 
            descripcionactividad:''

        }
    },
    mounted(){        
        this.id = parseInt(this.$route.params.id.split('-'));
        this.fecha = this.$store.getters.enviarDataSeguimientoProyectos[this.id].fecha; 
        this.nombreproyecto = this.$store.getters.enviarDataSeguimientoProyectos[this.id].nombreproyecto; 
        this.nombreinforme = this.$store.getters.enviarDataSeguimientoProyectos[this.id].nombreinforme; 
        this.descripcionactividad = this.$store.getters.enviarDataSeguimientoProyectos[this.id].descripcionactividad; 
        this.mostrarimagenes();

    },
    methods:{
        mostrarimagenes(){   //https://www.youtube.com/watch?v=eyeq1VQwcvg&list=UUsbDM9y4RJeDy_2DKc0aPaw  
            refe.child(`/imagenes/informes/${this.nombreinforme}`)
            .listAll()
            .then((resp) => {
                //console.log(resp)
                resp.items.map((item) => {
                    refe.child(item.location.path_)
                    .getDownloadURL()
                    .then((url) => {
                        this.imagendesc = true
                        this.imagenes.push(url)                       
                        //console.log(this.imagenes) 
                    })
                } )
            })
            
        },
        imprimirInforme(){
            window.print();
        },
        imprimirPDF(){
            const doc = new jsPDF();
            //const html = this.$refs.content.innerHTML
                                

             let lMargin=15; //left margin in mm
             let rMargin=15; //right margin in mm
             let pdfInMM=210;  // width of A4 in mm
                //doc.text("Contrato de Asesoría", 20, 40);
                //https://stackoverrun.com/es/q/10818673
                //https://codingshiksha.com/vue/vue-js-pdf-generator-in-vuetify-ui-using-jspdf-and-jspdf-autotable-library-full-tutorial-for-beginners/
                


             
        let lines =doc.splitTextToSize(this.descripcionactividad, (pdfInMM-lMargin-rMargin)); 
            
            doc.text("Contrato de Asesoría"+this.nombreinforme , 30, 40)
            doc.text(lMargin,60,lines);
            
           
                doc.save("Informe.pdf")
        },
            

        exportPdf(urls) { 
            console.log(urls.length)
                 let pdf = new jsPDF('l', 'mm', 'letter'); 
                 const pageWidth = pdf.internal.pageSize.getWidth(); 
                 const pageHeight = pdf.internal.pageSize.getHeight(); 
                 const pageRatio = pageWidth / pageHeight; 

                
                 for (let i = 0; i < urls.length; i++) { 
                     let img = new Image(); 
                     img.src = urls[i]; 
                     img.onload = function () { 
                         const imgWidth = this.width; 
                         const imgHeight = this.height; 
                         const imgRatio = imgWidth / imgHeight; 
                         if (i > 0) { 
                             pdf.addPage(); 
                             } 
                             pdf.setPage(i + 1); 
                             if (imgRatio >= 1) { 
                                 const wc = imgWidth / pageWidth; 
                                 if (imgRatio >= pageRatio) { 
                                     pdf.addImage(img, 'JPEG', 0, (pageHeight - imgHeight / wc) / 2, pageWidth, imgHeight / wc, null, 'NONE'); 
                                     } else 
                                     { const pi = pageRatio / imgRatio; 
                                     pdf.addImage(img, 'JPEG', (pageWidth - pageWidth / pi) / 2, 0, pageWidth / pi, (imgHeight / pi) / wc, null, 'NONE'); } 
                                } else { 
                                    const wc = imgWidth / pageHeight; if (1 / imgRatio > pageRatio) 
                                    { const ip = (1 / imgRatio) / pageRatio; const margin = (pageHeight - ((imgHeight / ip) / wc)) / 4; 
                                    pdf.addImage(img, 'JPEG', (pageWidth - (imgHeight / ip) / wc) / 2, -(((imgHeight / ip) / wc) + margin), pageHeight / ip, (imgHeight / ip) / wc, null, 'NONE', -90); 
                                } else { pdf.addImage(img, 'JPEG', (pageWidth - imgHeight / wc) / 2, -(imgHeight / wc), pageHeight, imgHeight / wc, null, 'NONE', -90); 
                                } } 
                                if (i == urls.length - 1) { pdf.save('Photo.pdf'); } } } 
                }
        
            
            
        
    }
}
</script>

<style>

</style>